
import { mapGetters } from 'vuex'
import Modal from '~/components/Shared/Modal/index.vue'
import VideoPlayer from '~/components/VideoPlayer/videojs.vue'
import Purchase from '../PurchaseAction/Purchase.vue'
import { Currency } from '~/plugins/Currency'
import { convertToSlug } from '~/helpers/generate-slug'
export default {
  data() {
    return {
      st: this.$store.state.settings.contents[this.$i18n.locale],
      showPayments: false,
      loginForPreviewModal: false,
      showVideo: false,
      showYoutube: '',
      videoOptions: {
        live: false,
        autoplay: this.modal,
        controls: true,
        playbackRates: [0.5, 1, 1.5, 2],
        sources: [
          {
            src: this.$api.path(this.product.videoPath),
            type: 'video/mp4',
          },
        ],
      },
    }
  },
  props: {
    product: {
      default: () => {
        return {
          imagePath: '',
        }
      },
    },
  },
  computed: {
    ...mapGetters({
      getUserIP: 'user/getUserIP',
      getActiveUser: 'user/getActiveUser',
      getReturnUrl: 'getReturnUrl',
    }),
    commentLength() {
      return this.product.comments === null ? 0 : this.product.comments.length
    },
    starAvg() {
      if (this.product.comments === null) return 0
      if (this.product.comments.length === 0) return 0
      const length =
        this.product.comments === null ? 0 : this.product.comments.length
      const totalStar = this.product.comments.reduce(
        (sum, { point }) => sum + point,
        0
      )
      return Math.round(totalStar / length)
    },
    videoLength() {
      return this.product.sections.reduce(
        (sum, { videos }) => sum + videos.length,
        0
      )
    },
  },
  methods: {
    Currency,
    convertToSlug,
    GET_QUERY_ACTIONS() {
      const q = this.$route.query
      if (q.action === 'fast-buy' && this.getActiveUser.token)
        this.showPayments = true
      else if (q.action === 'fast-buy') this.loginForPreviewModal = true
    },
    SET_SOURCE() {
      if (this.product.videoPath.includes('www.youtube.com/watch?v=')) {
        this.showYoutube = this.product.videoPath.split(
          'www.youtube.com/watch?v='
        )[1]
      }
    },
    CALCULATE_PERCENT() {
      if (!this.getActiveUser.token)
        return {
          videoCount: 0,
          doneVideoCount: 0,
          percent: 0,
        }
      const sections = this.product.sections
      const videoCount = sections.reduce(
        (sum, { videos }) => sum + videos.length,
        0
      )
      const doneVideoCount = sections.reduce(
        (sum, { videos }) =>
          sum + videos.filter((v) => v.isFinished === 1).length,
        0
      )
      return {
        videoCount,
        doneVideoCount,
        percent:
          videoCount > 0
            ? Math.round((doneVideoCount * 100) / videoCount) + 1
            : 0,
      }
    },
  },
  components: { Modal, VideoPlayer, Purchase },
  mounted() {
    this.SET_SOURCE()
    this.GET_QUERY_ACTIONS()
  },
}
